import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '@ridango/core';
import { takeUntil } from 'rxjs/operators';
import { OpenTripPlannerService } from '@ridango/components';
import { MapApiService } from '@ridango/widgets';
import { LatLng } from '@ridango/core';

@Component({
    templateUrl: './explore-stop-details-page.component.html'
})
export class ExploreStopDetailsPageComponent extends BaseComponent implements AfterViewInit {
    constructor(
        private route: ActivatedRoute,
        private openTripPlannerService: OpenTripPlannerService,
        private mapApi: MapApiService
    ) {
        super();
    }

    ngAfterViewInit(): void {
        this.route.params.pipe(takeUntil(this.componentDestroyed$)).subscribe((params) => {
            const stopId = params['stopId'];
            if (!stopId) {
                return;
            }
            this.openTripPlannerService
                .getStop(stopId)
                .pipe(takeUntil(this.componentDestroyed$))
                .subscribe((stop) => {
                    const latLng: LatLng = { lat: stop.lat, lng: stop.lon };
                    this.mapApi.centerMapToCoordinates(latLng);
                });
        });
    }
}
